import React, { useState, useEffect } from 'react';

import { Modal } from '@eb/eds-modal';
import { ProgressIndicator } from '@eb/eds-progress-indicator';

import { SOFT_ACCOUNT_EMAIL_STATUSES } from '../constants/status';

import SoftAccountStatusPage from '../containers/softAccountStatus/ConnectedSoftAccountStatusPage';

const loadingState = (
    <div className="eds-l-pad-all-8 eds-align--center">
        <ProgressIndicator
            size="large-chunky"
            shape="circular"
            style="gradient"
        />
    </div>
);

const SoftAccountModal = ({
    handleSoftAccount,
    dataTestId = 'soft-account-modal',
    softAccountEmailStatus,
    setShowModal,
}) => {
    const [isModalOpen, setIsModalOpen] = useState(true);
    const [modalBody, setModalBody] = useState(loadingState);

    //Run only once at open
    useEffect(() => {
        handleSoftAccount();
        setIsModalOpen(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (
            softAccountEmailStatus === SOFT_ACCOUNT_EMAIL_STATUSES.delivered ||
            softAccountEmailStatus === SOFT_ACCOUNT_EMAIL_STATUSES.failed
        ) {
            setModalBody(
                <SoftAccountStatusPage
                    softAccountEmailStatus={softAccountEmailStatus}
                />,
            );
        } else {
            setModalBody(loadingState);
        }
    }, [softAccountEmailStatus]);

    return (
        <div data-testid={dataTestId}>
            <Modal
                noMinHeight={true}
                modalBodyIsEmpty={true}
                isShown={isModalOpen}
                onClose={() => {
                    setIsModalOpen(false);
                    setModalBody(loadingState);
                    setShowModal(false);
                }}
            >
                {modalBody}
            </Modal>
        </div>
    );
};

export default SoftAccountModal;
